import React from "react";
import { increaseResourceDownloadCount } from "../services/resourceService";

function ResourceCard({ item }) {
  // Check if this is a dynamic API resource
  const isDynamic = !!item.fileUrl;

  const handleDownload = () => {
    if (isDynamic) {
      increaseResourceDownloadCount(
        item.category,
        item.folderName,
        item.fileName
      );
    }
  };

  if (isDynamic) {
    const fileName = item.fileName || "";
    const lastDotIndex = fileName.lastIndexOf(".");
    const fileNameWithoutExtension = lastDotIndex !== -1
      ? fileName.substring(0, lastDotIndex)
      : fileName;

    const extension = item.fileType || "";

    // Determine the icon to display
    let iconSrc = null;
    let iconClass = "bi bi-file-earmark-text text-secondary";

    if (item.fileIcon) {
      iconSrc = `data:image/png;base64,${item.fileIcon}`;
    } else if (["mp3", "aac", "wav", "m4a"].includes(extension.toLowerCase())) {
      iconClass = "bi bi-file-earmark-music text-primary";
    } else if (extension.toLowerCase() === "zip") {
      iconClass = "bi bi-file-earmark-zip text-warning";
    } else if (extension.toLowerCase() === "pdf") {
      iconClass = "bi bi-file-earmark-pdf text-danger";
    } else if (["pptx", "ppt"].includes(extension.toLowerCase())) {
      iconClass = "bi bi-file-earmark-ppt text-danger";
    }

    return (
      <a
        href={item.fileUrl}
        download={item.fileName}
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleDownload}
        className="resource-card-link"
        style={{ textDecoration: "none", color: "inherit" }}
      >
        <div className="resource-card">
          <div className="resource-title" title={fileNameWithoutExtension}>
            {fileNameWithoutExtension}
          </div>
          {iconSrc ? (
            <img
              src={iconSrc}
              alt={fileNameWithoutExtension}
              className="resource-image"
            />
          ) : (
            <div className="resource-icon-container d-flex justify-content-center align-items-center" style={{ height: "70px", fontSize: "2.5rem" }}>
              <i className={iconClass}></i>
            </div>
          )}
        </div>
      </a>
    );
  }

  // Fallback for static mock data
  return (
    <div className="resource-card">
      <div className="resource-title">
        {item.title}
      </div>
      <img
        src={item.image}
        alt=""
        className="resource-image"
      />
    </div>
  );
}

export default ResourceCard;